var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResumeModern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_1097)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.27,
    filter: "url(#filter0_f_77_1097)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.391,
    cy: 40.4823,
    rx: 11.6551,
    ry: 4.95623,
    fill: "#F2D484"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_77_1097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.736,
    y: 12.9167,
    width: 23.4818,
    height: 27.5655,
    rx: 4.84981,
    fill: "url(#paint0_linear_77_1097)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bi_77_1097)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.736,
    cy: 18.7243,
    r: 2.93862,
    fill: "#FBFFFE",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bi_77_1097)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.736,
    cy: 35.1229,
    r: 2.93862,
    fill: "#FBFFFE",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bi_77_1097)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.736,
    cy: 26.9235,
    r: 2.93862,
    fill: "#FBFFFE",
    fillOpacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bi_77_1097)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0943 12.9165L36.0943 40.4837L32.7476 40.4837L32.7476 12.9165L36.0943 12.9165Z",
    fill: "#FBFFFE",
    fillOpacity: 0.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_77_1097",
    x: 10.2173,
    y: 29.0076,
    width: 36.3473,
    height: 22.9495,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25928,
    result: "effect1_foregroundBlur_77_1097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_77_1097",
    x: 10.4312,
    y: -0.66271,
    width: 40.9411,
    height: 45.0247,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.4249,
    dy: -4.84981
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.36483
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.991667 0 0 0 0 0.94167 0 0 0 0 0.491701 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_77_1097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_77_1097",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bi_77_1097",
    x: 11.3725,
    y: 13.3607,
    width: 10.7271,
    height: 10.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.21245
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1097",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.93992
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.969961
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_77_1097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bi_77_1097",
    x: 11.3725,
    y: 29.7594,
    width: 10.7271,
    height: 10.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.21245
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1097",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.93992
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.969961
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_77_1097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bi_77_1097",
    x: 11.3725,
    y: 21.56,
    width: 10.7271,
    height: 10.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.21245
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1097",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.93992
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.969961
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_77_1097"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bi_77_1097",
    x: 25.4728,
    y: 5.64179,
    width: 17.8962,
    height: 42.1166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.63736
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_77_1097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_77_1097",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.484981
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21245
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_77_1097"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_77_1097",
    x1: 28.4768,
    y1: 12.9167,
    x2: 44.189,
    y2: 60.4985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4D689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1BC5C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_1097"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeModern);
export default __webpack_public_path__ + "static/media/resume_modern.788536537660b8749849c5197948b465.svg";
export { ForwardRef as ReactComponent };